export const font = {
    nunito: `'Nunito', sans-serif`,
    nova: `proxima-nova, sans-serif !important`
};